import { ITranslationResource } from 'ngx-translate-multi-http-loader';

export const TRANSLATIONS_VERSION = '1.11';

export const TRANSLATIONS: ITranslationResource[] = [
  { prefix: `/translations/{{lang}}/auth.`, suffix: '.json' },
  { prefix: `/translations/{{lang}}/extension.`, suffix: '.json' },
  { prefix: `/translations/{{lang}}/profile.`, suffix: '.json' },
  { prefix: `/translations/{{lang}}/shared.`, suffix: '.json' },
  { prefix: `/translations/{{lang}}/ui.`, suffix: '.json' },
];
